import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema, isEmpty } from "../../../Schema";
import { yesNoBooleanOptions } from "..";

export const isBookable: FieldSchema = {
  grid: {
    displayed: true,
    order: 10,
    ignoredForSearch: true,
  },
  name: "isBookable",
  data: {
    variant: DataVariants.ENUM,
    options: yesNoBooleanOptions,
    assignedValue: {
      getter: ({ isBookable }) => isEmpty(isBookable) ? false : isBookable,
    },
  },
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: { label: "Available in booking", type: InputTypes.SELECT },
};
